import React, { useState, useEffect, useRef } from 'react';
import Styles from '../AiProjectCharter.module.scss';
import DateInput from "../../../components/controls/input/customInput/CustomInput";
import { CalendarIcon } from 'lucide-react';
import DropDown from "../../../components/controls/dropdown/DropdownFluent";
import Searchable from "../../../components/controls/select/CustomSelect";



const EditableField = ({ label, value, onChange, type = 'text', error, required, multiline, options, min, max, suffix, prefix, seacrhPlaceholder ,onSearch, creatableSearch, isRequired }) => {
    const [editing, setEditing] = useState(false);
    const [tempValue, setTempValue] = useState(value || '');
    const [isDatePickerVisible, setDatePickerVisible] = useState(false);
    const inputRef = useRef(null);

    const formatDate = (dateString) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    };

    useEffect(() => {
      setTempValue(value || '');
    }, [value]);
  
    useEffect(() => {
      if (editing) {
        if(type == 'date') 
          setDatePickerVisible(true);
        else if(inputRef.current){
          if(type == 'select' || type == 'search')
            inputRef.current.click();
          else{
            inputRef.current.focus();
          }
        }

      }
    }, [editing]);
  
    const handleSave = () => {
      onChange(tempValue);
      setEditing(false);
    };

    const handleChangeAndSave = (value) => {
      setTempValue(value);
      onChange(value);
      setEditing(false);
    };
  
    const formatDisplayValue = () => {
      if (type === 'date' && value) {
        return formatDate(value);
      }
      if (type === 'select' && options) {
        const option = options.find(opt => opt.value == value);
        return option ? option.name : "";
      }
      if (type === 'search' && options) {
        const option = options.find(opt => opt.value == value);
        return option ? option.label : "";
      }
      if (prefix && suffix) {
        return `${prefix}${value || 0}${suffix}`;
      }
      if (prefix) {
        return `${prefix}${value || 0}`;
      }
      if (suffix) {
        return `${value || 0}${suffix}`;
      }
      return value || '';
    };
  
    return (
      <div className={Styles.Field}>
        <label className="text-xsm-600 grey10Color">
          {label}{required && <span style={{ color: '#c50f1f' }}> *</span>}
        </label>
        {!editing ? (
          <div
            className={`${Styles.FieldValue} ${error ? Styles.FieldError : ''}`}
            onClick={() => setEditing(true)}
          >
            <span className="text-sm-400">{formatDisplayValue()}</span>
          </div>
        ) : (
          <>
            {type === 'select' ? (
              <DropDown
                inputRef={inputRef}
                label={label}
                showLabel={false}
                StyleClass={Styles.DropDown}
                options={options}
                defaultVal={options.find(opt => opt.value == tempValue)?.name || ""}
                onChange={handleChangeAndSave}
            />
            ) : 
            type === 'date' ? (
              <DateInput
                ref={inputRef}
                value={tempValue}
                minDate={min}
                maxDate={max}
                type="date"
                handleChange={handleChangeAndSave}
                DateStyleClass={Styles.FieldInput}
                openPicker={isDatePickerVisible}
              />
            ) :
            type === 'search' ?
            (
            <Searchable
              SelectText={seacrhPlaceholder || "option"}
              searchText={onSearch}
              options={options}
              defaultVal={options?.find(opt => opt.value == tempValue)}
              onChange={handleChangeAndSave}
              isRequired={isRequired}
              CustomClass={Styles.Searchable}
              creatable={creatableSearch}
              setCreated={handleChangeAndSave}
            />
          ):
            multiline ? (
              <textarea
                ref={inputRef}
                value={tempValue}
                onChange={(e) => setTempValue(e.target.value)}
                onBlur={handleSave}
                className={Styles.FieldInput}
                rows={3}
              />
            ) : (
              <input
                ref={inputRef}
                type={type}
                value={tempValue}
                onChange={(e) => setTempValue(e.target.value)}
                onBlur={handleSave}
                className={Styles.FieldInput}
                min={min}
                max={max}
              />
            )}
          </>
        )}
        {error && <span className="text-xsm-400" style={{ color: '#c50f1f' }}>{error}</span>}
      </div>
    );
  };

export default EditableField;